var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.container]},[_c('honjo-logo',{attrs:{"title":"普洛斯金融","expand":_vm.expand}}),_c('el-switch',{model:{value:(_vm.expand),callback:function ($$v) {_vm.expand=$$v},expression:"expand"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }